import * as React from 'react';
import { ISelectorDefault, search_param } from '../../_types/search';
import Typography from '@material-ui/core/Typography';
interface Props {
    searchParam: search_param;
    selector_cn: string;
    disabled?: boolean;
};

export const OnlyTrueSelectorDefaults = 
    (selector_cn: string): ISelectorDefault => {
        return { 
            comparison: "equals",
            values: ["1"]
        };
    };

const OnlyTrueSelector: React.FC<Props> = (prop: Props) => {

    //const userState: IUserState = useContext(AuthContext);

    

    // const _value = ():boolean => {

    //     return true;
    // }


return (
    <Typography>True</Typography>
)
}

export default OnlyTrueSelector;